import { getRuntimeConfig } from '../runtimeConfig';

export const getRoutingStrategy = () => {
  const config = getRuntimeConfig();
  const strategy = config.VITE_ROUTING_STRATEGY;

  // Validate the strategy value
  if (strategy === 'path' || strategy === 'header') {
    return strategy;
  }

  // Log warning for invalid values in development
  if (strategy && process.env.NODE_ENV === 'development') {
    console.warn(
      `Invalid VITE_ROUTING_STRATEGY: "${strategy}". Falling back to "header". ` +
        `Valid values are: "header", "path"`,
    );
  }

  return 'header';
};
